import { render, staticRenderFns } from "./RankingCard.vue?vue&type=template&id=5784aab7&scoped=true"
import script from "./RankingCard.vue?vue&type=script&lang=js"
export * from "./RankingCard.vue?vue&type=script&lang=js"
import style0 from "./RankingCard.vue?vue&type=style&index=0&id=5784aab7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5784aab7",
  null
  
)

export default component.exports